import { render, staticRenderFns } from "./viewMessageTemplate.vue?vue&type=template&id=002bb3e6&scoped=true"
import script from "./viewMessageTemplate.vue?vue&type=script&lang=js"
export * from "./viewMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./viewMessageTemplate.vue?vue&type=style&index=0&id=002bb3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002bb3e6",
  null
  
)

export default component.exports